import { connect } from 'react-redux'
import SetAgeGroup from './set-age-group'
import { isOpen, getPupilsIds } from './set-age-group.selectors'
import { closeAgeGroupDialog } from './set-age-group.actions'
import { getPupil } from '../../../../../stores/pupils/pupils.selectors'
import { updatePupil } from '../../../../../stores/pupils/pupils.actions'
import { errorHandler } from 'pobble-components/dist/error-handler'

const mapStateToProps = state => {
  const ids = getPupilsIds(state)
  let initialAgeGroup = false
  if (ids.length === 1) initialAgeGroup = getPupil(state, ids[0]).year_group.id
  return {
    ids: ids,
    opened: isOpen(state),
    initialAgeGroup: initialAgeGroup
  }
}

const mapDispatchToProps = dispatch => ({
  dispatch: dispatch,
  requestClose: () => dispatch(closeAgeGroupDialog())
})

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  onSubmit: ({ ageGroup }) => {
    dispatchProps.requestClose()
    stateProps.ids.forEach(id => {
      dispatchProps
        .dispatch(updatePupil(id, { year_group_id: ageGroup }))
        .catch(errorHandler)
    })
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(SetAgeGroup)
